import axios from '@/request/http'; // 导入http中创建的axios实例
import base from '@/request/api/base'// 导入接口域名列表
//调查问卷-培训班级相关接口
;

const myAllWork = {
  //列表数据
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/dcwj/plan/page`, params);
  },
  //列表数据
  getManagePage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/dcwj/plan/pageManage`, params);
  },
  //根据id查询单个信息
  getById(params) {
    return axios.get(`${base.bs}/admin/dcwj/plan/get/${params.id}`)
  },
  //保存修改
  save(params) {
    return axios.post(`${base.bs}/admin/dcwj/plan/save`, params)
  },
  //保存修改
  update(params) {
    return axios.post(`${base.bs}/admin/dcwj/plan/set`, params)
  },
  //根据id删除单个
  del(params) {
    return axios.get(`${base.bs}/admin/dcwj/plan/del/${params.id}`)
  },
  //批量删除
  batchDel(params) {
    return axios.post(`${base.bs}/admin/dcwj/plan/batchDel`,params)
  },
  //生成二维码
  createQrcode(params) {
    return axios.get(`${base.bs}/admin/dcwj/plan/createQrcode/${params.id}`,{params:{width:params.width,height:params.height}})
  },
  //保存调查问卷
  saveWj(params) {
    return axios.post(`${base.bs}/txdcwj/saveWj`, params)
  },
  //注销
  cancel(params) {
    return axios.get(`${base.bs}/admin/dcwj/plan/cancel/${params.id}`)
  },
  //注销恢复
  recovery(params) {
    return axios.get(`${base.bs}/admin/dcwj/plan/recovery/${params.id}`)
  },
}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/dcwj/plan.js